// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccessBoardController from "./access_board_controller"
application.register("access-board", AccessBoardController)

import ActivityBoardController from "./activity_board_controller"
application.register("activity-board", ActivityBoardController)

import ActivityFiltersController from "./activity_filters_controller"
application.register("activity-filters", ActivityFiltersController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AppChromeController from "./app_chrome_controller"
application.register("app-chrome", AppChromeController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import AvatarEditorController from "./avatar_editor_controller"
application.register("avatar-editor", AvatarEditorController)

import BillingPurchaseController from "./billing_purchase_controller"
application.register("billing-purchase", BillingPurchaseController)

import CadastreController from "./cadastre_controller"
application.register("cadastre", CadastreController)

import CardPanelController from "./card_panel_controller"
application.register("card-panel", CardPanelController)

import CardScreenChromeController from "./card_screen_chrome_controller"
application.register("card-screen-chrome", CardScreenChromeController)

import ChangeImpactDialogController from "./change_impact_dialog_controller"
application.register("change-impact-dialog", ChangeImpactDialogController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import DocumentationNavigationController from "./documentation_navigation_controller"
application.register("documentation-navigation", DocumentationNavigationController)

import ExplicitSubmitController from "./explicit_submit_controller"
application.register("explicit-submit", ExplicitSubmitController)

import FileUploadsController from "./file_uploads_controller"
application.register("file-uploads", FileUploadsController)

import KeyboardBarController from "./keyboard_bar_controller"
application.register("keyboard-bar", KeyboardBarController)

import MediaViewerController from "./media_viewer_controller"
application.register("media-viewer", MediaViewerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NativeNoteEditorController from "./native_note_editor_controller"
application.register("native-note-editor", NativeNoteEditorController)

import NativeNoteCaptureController from "./native_note_capture_controller"
application.register("native-note-capture", NativeNoteCaptureController)

import NoteAttachmentsController from "./note_attachments_controller"
application.register("note-attachments", NoteAttachmentsController)

import PasskeyAuthController from "./passkey_auth_controller"
application.register("passkey-auth", PasskeyAuthController)

import PasskeyRegistrationController from "./passkey_registration_controller"
application.register("passkey-registration", PasskeyRegistrationController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import QuickSearchController from "./quick_search_controller"
application.register("quick-search", QuickSearchController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SearchShortcutController from "./search_shortcut_controller"
application.register("search-shortcut", SearchShortcutController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)


import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)
